export const EQUIPAMIENTO_FILTROS_STORAGE_KEY = 'EquipamientoGrid_filtros';

const ANCHO_MEDIO = { xs: 12, sm: 6, md: 3, lg: 3 };

export const buildEquipamientoFilterFields = (intl) => [
	{
		name: 'identificador',
		type: 'text',
		label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.identificador', defaultMessage: 'Identificador' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'tipo',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.tipo', defaultMessage: 'Tipo' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'marca',
		type: 'text',
		label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.marca', defaultMessage: 'Marca' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'modelo',
		type: 'text',
		label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.modelo', defaultMessage: 'Modelo' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'vehiculo',
		type: 'text',
		label: intl.formatMessage({ id: 'equipamientoGrid.columns_label.movil', defaultMessage: 'Móvil' }),
		size: ANCHO_MEDIO,
	},
];
